/**
 * @author: liaojianming
 * @date 2019-02-21
 * @description: 表单验证相关
*/

export default {
    checkEmail: function(email) {
        var reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
        return reg.test(email);
    },
    checkPhone: function(phone) {
        var reg = /^1[3456789]\d{9}$/;
        return reg.test(phone);
    },
    checkPassword: function(psd) {
        var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._\@]){7,19}$/;
        return reg.test(psd);
    },
    // 验证英文
    checkEnglishStr: function(roleKey) {
        var reg = /[a-zA-Z]/;
        return reg.test(roleKey);
    },
    // 验证正整数
    checkInteger: function(num) {
        var reg = /^\d+$/;
        return reg.test(num);
    }
}